(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const aidenLink = event.target.closest('a.menu-link--aiden[data-advisor-id]');
    if (aidenLink) {
      event.preventDefault();
      return;
    }

    const aidenSummary = event.target.closest('summary[data-advisor-id]');
    if (aidenSummary) {
      event.preventDefault();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
